import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { DividerModule } from "primeng/divider";

/* 
  Example usage:
  {
    type: "header",
    props: {
      label: {
        en: "Header Title",
        fi: "Otsikon otsikko",
        sv: "Rubrikens titel",
      },
      description: {
        en: "Some great description text under the header",
        fi: "Hieno kuvausteksti otsikon alla",
        sv: "Bra beskrivningstext under rubriken",
      },                                                        // OPTIONAL: Description text below the header
      titleSize: "xl",                                          // OPTIONAL: Can be 'xs', 'sm', 'base', 'lg', 'xl', '2xl' and other tailwindcss text sizes
      fontWeight: "bold",                                       // OPTIONAL: Can be 'normal', 'semibold', 'bold' and other tailwindcss font weights
      marginTop: 1,                                             // OPTIONAL: Number of rems for top margin
      marginBottom: 1,                                          // OPTIONAL: Number of rems for bottom margin
      showDivider: true,                                        // OPTIONAL: Whether to show a divider below the header
      required: true,                                           // OPTIONAL: Purely visual - shows a red asterisk after the label, does not affect validation
    },
  },

  ////////////////////

  JSON example:

  {
    "type": "header",
    "props": {
      "label": {
        "en": "Header Title",
        "fi": "Otsikon otsikko",
        "sv": "Rubrikens titel"
      },
      "description": {
        "en": "Some great description text under the header",
        "fi": "Hieno kuvausteksti otsikon alla",
        "sv": "Bra beskrivningstext under rubriken"
      },                                                        // OPTIONAL: Description text below the header
      "titleSize": "xl",                                          // OPTIONAL: Can be 'xs', 'sm', 'base', 'lg', 'xl', '2xl' and other tailwindcss text sizes
      "fontWeight": "bold",                                       // OPTIONAL: Can be 'normal', 'semibold', 'bold' and other tailwindcss font weights
      "marginTop": 1,                                             // OPTIONAL: Number of rems for top margin
      "marginBottom": 1,                                          // OPTIONAL: Number of rems for bottom margin
      "showDivider": true,                                        // OPTIONAL: Whether to show a divider below the header
      "required": true                                            // OPTIONAL: Purely visual - shows a red asterisk after the label, does not affect validation
    }
  },
*/

@Component({
  selector: "app-formly-type-header",
  templateUrl: "./header.type.html",
  standalone: true,
  imports: [CommonModule, DividerModule],
})
export class HeaderComponent extends FieldType<FieldTypeConfig> {
  get showDivider(): boolean {
    return this.props["showDivider"] ?? false;
  }

  get titleSize(): string {
    return `text-${this.props["titleSize"] ?? "lg"}`;
  }

  get fontWeight(): string {
    return `font-${this.props["fontWeight"] ?? "semibold"}`;
  }

  get marginTop(): string {
    return String(this.props["marginTop"] ?? 0);
  }

  get marginBottom(): string {
    return String(this.props["marginBottom"] ?? 0);
  }
}
